import { Component, input, output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-tonal-button',
  imports: [MatButton, MatIcon],
  templateUrl: './tonal-button.component.html',
  styleUrl: './tonal-button.component.scss'
})
/**
 * Begründung: Hierbei handelt es sich um eine allgemeine Komponente, daher keine Afo erfüllt
 */
export class TonalButtonComponent {
  buttonText = input.required<string>();
  counter = input<number>(0);
  dataTestId = input<string>();
  icon = input<string>('plus-icon');
  clicked = output<MouseEvent>();

  onClick(event: MouseEvent): void {
    this.clicked.emit(event);
  }
}
